import React from 'react';
import { SignInButton } from "@clerk/clerk-react";
import {
  ArrowRight, Terminal, Cpu, Zap, Shield, Code, Globe, Sparkles
} from 'lucide-react';

const LandingPage = () => {
  return (
    <div className="min-h-screen w-full bg-[#05070A] text-white font-sans overflow-x-hidden flex flex-col">

      {/* --- NAVBAR --- */}
      <nav className="relative z-20 flex items-center justify-between px-5 sm:px-8 md:px-10 py-5 md:py-6 max-w-7xl mx-auto w-full">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-[#0047AB] rounded-full flex items-center justify-center">
            <Terminal size={18} className="text-white" />
          </div>
          <span className="text-lg sm:text-xl font-bold tracking-tight">
            Orquest<span className="text-[#0047AB]">SAP.</span>
          </span>
        </div>
        <SignInButton mode="modal">
          <button className="px-5 py-2 rounded-full border border-white/10 text-[11px] sm:text-[12px] font-bold hover:bg-white hover:text-black transition-all">
            Login
          </button>
        </SignInButton>
      </nav>

      {/* --- CONTENIDO PRINCIPAL: DOS COLUMNAS --- */}
      <div className="relative flex-1 w-full max-w-7xl mx-auto px-5 sm:px-8 md:px-10 py-10 sm:py-16 flex flex-col lg:flex-row gap-10 lg:gap-16 items-stretch">

        {/* IMAGEN DE FONDO GLOBAL */}
        <div className="absolute inset-0 z-0 overflow-hidden">
          <img
            src="https://images.unsplash.com/photo-1677442136019-21780ecad995?q=80&w=2070&auto=format&fit=crop"
            alt="AI Background"
            className="w-full h-full object-cover opacity-20 grayscale-[0.5]"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#05070A]/60 via-[#05070A]/40 to-[#05070A]/80"></div>
        </div>

        {/* ── COLUMNA IZQUIERDA — HERO ── */}
        <div className="relative z-10 flex-1 flex flex-col justify-center items-start">
          <div className="w-full backdrop-blur-md bg-black/40 border border-white/10 rounded-[28px] sm:rounded-[40px] p-7 sm:p-10 flex flex-col items-start text-left shadow-2xl">

            <span className="text-[#0047AB] text-[10px] sm:text-xs font-black uppercase tracking-[0.3em] mb-4">
              Orquest SAP Engine V5.6.2
            </span>

            <h1 className="text-[1.9rem] sm:text-4xl md:text-5xl font-bold leading-[1.1] mb-5 tracking-tight">
              LA EVOLUCIÓN DEL <br />
              <span className="text-white">CONSULTOR SAP</span>
            </h1>

            <p className="text-slate-300 text-sm sm:text-base max-w-sm mb-8 font-light leading-relaxed">
              IA Generativa + ABAP Cloud. El orquestador técnico definitivo diseñado para liderar la nueva generación de ecosistemas SAP.
            </p>

            <SignInButton mode="modal">
              <button className="group bg-white text-black px-7 py-3 rounded-2xl font-black text-xs sm:text-sm uppercase tracking-widest flex items-center gap-3 hover:scale-105 transition-all shadow-[0_0_30px_rgba(212,255,63,0.3)] mb-10">
                Empezar a Generar
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
              </button>
            </SignInButton>

            <div className="flex flex-wrap items-center gap-5 opacity-50 grayscale transition-all hover:grayscale-0 hover:opacity-100">
              <div className="flex items-center gap-2 text-[9px] font-black tracking-widest uppercase"><Cpu size={13} /> S/4HANA</div>
              <div className="flex items-center gap-2 text-[9px] font-black tracking-widest uppercase"><Zap size={13} /> CLEAN CORE</div>
              <div className="flex items-center gap-2 text-[9px] font-black tracking-widest uppercase"><Shield size={13} /> BTP READY</div>
            </div>
          </div>
        </div>

        {/* ── COLUMNA DERECHA — SERVICIOS ── */}
        <div className="relative z-10 flex-1 flex flex-col justify-center gap-5">

          {/* Header servicios */}
          <div>
            <span className="text-[#0047AB] text-[10px] font-black uppercase tracking-[0.4em] mb-2 block">
              Servicios Profesionales
            </span>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight mb-3">
              DESARROLLO A MEDIDA <br />
              <span className="text-[#0047AB]">PARA TU EMPRESA</span>
            </h2>
            <p className="text-slate-400 text-sm max-w-md font-light leading-relaxed mb-4">
              Experiencia en proyectos SAP S/4HANA. Desarrollo freelance de soluciones
              personalizadas con IA · BTP · Fiori · CAP · RAP · CDS.
            </p>

            {/* Datos contacto */}
            <div className="grid grid-cols-2 gap-2 mb-4">
              {[
                { label: "Andrés Cáceres", icon: "👤", link: null },
                { label: "infoabapfi@gmail.com", icon: "✉️", link: "mailto:infoabapfi@gmail.com" },
                { label: "+54 9 11 6718 4173", icon: "📱", link: "tel:+5491167184173" },
                { label: "Argentina", icon: "🌎", link: null },
                { label: "WhatsApp", icon: "whatsapp", link: "https://wa.me/5491167184173" },
              ].map((item) => {
                const icono = item.icon === "whatsapp" ? (
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="currentColor" style={{ color: '#22c55e' }}>
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                  </svg>
                ) : <span>{item.icon}</span>;

                return item.link ? (
                  <a
                    key={item.label}
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-4 py-2 hover:border-[#0047AB]/50 hover:bg-[#0047AB]/10 transition-all"
                  >
                    {icono}
                    <span className="text-[11px] font-bold text-slate-300 tracking-wide">
                      {item.label}
                    </span>
                  </a>
                ) : (
                  <div
                    key={item.label}
                    className="flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-4 py-2"
                  >
                    {icono}
                    <span className="text-[11px] font-bold text-slate-300 tracking-wide">
                      {item.label}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Cards servicios */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            {[
              {
                icon: <Sparkles size={16} className="text-[#0047AB]" />,
                title: "Programas IA a Medida",
                desc: "Soluciones SAP con IA generativa adaptadas a los procesos de tu empresa."
              },
              {
                icon: <Globe size={16} className="text-[#0047AB]" />,
                title: "Fiori & BTP Freelance",
                desc: "Apps Fiori Elements y freestyle sobre SAP BTP con OData y CAP model."
              },
              {
                icon: <Code size={16} className="text-[#0047AB]" />,
                title: "Arquitectura S/4HANA",
                desc: "Migración legacy a S/4HANA. Clean ABAP, CDS Views, AMDP y rendimiento."
              },
            ].map((s) => (
              <div
                key={s.title}
                className="group bg-white/3 border border-white/8 rounded-[20px] p-4 hover:border-[#0047AB]/50 hover:bg-[#0047AB]/5 transition-all duration-300"
              >
                <div className="w-8 h-8 bg-[#0047AB]/15 border border-[#0047AB]/30 rounded-xl flex items-center justify-center mb-3 group-hover:scale-110 transition-transform">
                  {s.icon}
                </div>
                <h3 className="text-[11px] font-black uppercase tracking-wide text-white mb-1">
                  {s.title}
                </h3>
                <p className="text-[10px] text-slate-500 leading-relaxed">
                  {s.desc}
                </p>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="bg-gradient-to-r from-[#0047AB]/10 to-transparent border border-[#0047AB]/20 rounded-[20px] p-5 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="text-[10px] font-black text-[#0047AB] uppercase tracking-widest mb-1">
                ¿Tu empresa necesita una solución SAP?
              </p>
              <h3 className="text-base sm:text-lg font-bold text-white">
                Hablemos de tu proyecto
              </h3>
              <p className="text-[10px] text-slate-500 mt-0.5">
                Respuesta en menos de 24 horas · Presupuesto sin cargo
              </p>
            </div>

            <a href="mailto:infoabapfi@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
              className="shrink-0 group bg-[#0047AB] text-white px-6 py-2.5 rounded-xl font-black text-[11px] uppercase tracking-widest flex items-center gap-2 hover:scale-105 transition-all shadow-lg shadow-[#0047AB]/20"
            >
              Contactar
              <ArrowRight size={13} className="group-hover:translate-x-1 transition-transform" />
            </a>
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <footer className="relative z-10 py-5 sm:py-8 px-5 sm:px-10 flex flex-col sm:flex-row justify-between items-center gap-2 border-t border-white/5 bg-[#05070A]">
        <p className="text-[9px] sm:text-[10px] font-bold text-slate-600 uppercase tracking-widest text-center">
          © 2026 ORQUEST SAP - BY ANDRÉS CÁCERES
        </p>
        <div className="flex gap-3 items-center">
          <div className="w-1.5 h-1.5 rounded-full bg-[#D4FF3F] animate-pulse"></div>
          <span className="text-[9px] font-black text-slate-500 uppercase tracking-[0.3em]">System Online</span>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;